import { makeStyles } from "@material-ui/core"

import { colors } from "@/styles/colors"

const useStyles = makeStyles({
	selectAllOption: {
		width: "100%"
	},
	selectAllOptionRow: {
		display: "flex",
		alignItems: "center"
	},
	selectAllOptionIcon: {
		width: 16,
		height: 16,
		marginRight: 6,
		color: colors.getPrimaryColor()
	},
	selectAllOptionLabel: {
		fontWeight: 800,
		color: colors.getPrimaryColor()
	},
	selectAllOptionDivider: {
		marginTop: 8
	},
	tagOption: {
		display: "flex",
		alignItems: "center",
		width: "100%"
	},
	tagColor: {
		width: 18,
		height: 18,
		marginRight: 8,
		flexShrink: 0
	},
	tagLabel: {
		flexGrow: 1
	}
})

export default useStyles
